export default "__VITE_ASSET__1af3346f__"